<template>
  <div>
    <vue-dropzone ref="locationDropzone" id="dropzone" :options="dropzoneOptions"></vue-dropzone>
    <media-library :location="location"></media-library>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  props: ['location', 'message', 'url', 'max-files'],
  components: {
    vueDropzone: vue2Dropzone
  },
  data() {
    return {
      dropzoneOptions: {
        addRemoveLinks: true,
        url: this.url,
        dictDefaultMessage: '<i class="fa fa-cloud-upload"></i> ' + this.message,
        maxFiles: this.maxFiles ? this.maxFiles : null
      }
    }
  },
  methods: {
    template() {
        return `<div class="dz-preview dz-file-preview">
                <div class="dz-image">
                    <div data-dz-thumbnail-bg></div>
                </div>
                <div class="dz-details">
                    <div class="dz-size"><span data-dz-size></span></div>
                    <div class="dz-filename"><span data-dz-name></span></div>
                </div>
                <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                <div class="dz-error-message"><span data-dz-errormessage></span></div>
                <div class="dz-success-mark"><i class="fa fa-check"></i></div>
                <div class="dz-error-mark"><i class="fa fa-close"></i></div>
            </div>
        `;
      }
  }
}
</script>
